import React from 'react';

const Header = () => {
  return (
    <header className="w-full border-b border-gray-100/30 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        {/* Logo - Perfect Width Alignment */}
        <div className="flex flex-col">
          <span className="text-4xl font-bold text-gray-900 tracking-tight">
            LinearCal
          </span>
          <span className="text-base text-gray-600 font-normal">
            The intelligent calendar
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
